import { Controller } from "@hotwired/stimulus"

export default class RemoteController extends Controller {
  handleRespone(ev) {
    const { detail: [, , xhr] } = event
    console.log(xhr.responseText, '-------')
    // window.ajaxErrorHandler(xhr)
  }    
}
